import { useEffect, useState } from 'react';
import { fetchInfoTemplateByJobId } from 'wisestep-api';

import { IInformationTemplateDetails } from '../../../features/jobs/post/components/SelectInformationTemplateDrawer';

const useJobInfoTemplates = (jobId: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [infoTemplates, setInfoTemplates] = useState<IInformationTemplateDetails[]>([]);
  useEffect(() => {
    jobId &&
      (async () => {
        try {
          setLoading(true);
          const evaluationReponse = await fetchInfoTemplateByJobId(jobId);
          setInfoTemplates(evaluationReponse.data);
        } catch (e) {
          console.error('Error while getting the  Job Info Templates', e);
        } finally {
          setLoading(false);
        }
      })();
  }, [jobId]);

  return { infoTemplates, loading };
};

export default useJobInfoTemplates;
